import { DataTableCountFooter } from './DataTableCountFooter';

interface EntityListCountFooterProps {
  count: number;
  singular: string;
}

export function EntityListCountFooter({ count, singular }: EntityListCountFooterProps) {
  return <DataTableCountFooter count={count} singular={singular} />;
}
